class EditorialCardHeightSync extends HTMLElement {
    constructor() {
        super();
        this.syncHeight = this.syncHeight.bind(this);
    }
    connectedCallback() {
        requestAnimationFrame(() => this.syncHeight());
        window.addEventListener("resize", this.syncHeight);
    }

    disconnectedCallback() {
        window.removeEventListener("resize", this.syncHeight);
    }

    syncHeight() {

        const singleCard = document.querySelector(".product-card-image-container");
        const editorialCards = document.querySelectorAll(".editorial-image-large");
        if (!singleCard || !editorialCards.length) return;

        const singleCardHeight = singleCard.offsetHeight;
        const singleCardWidth = singleCard.offsetWidth * 2 + 10;
        editorialCards.forEach((card) => {
            card.style.height = `${singleCardHeight}px`;
            card.style.width = `${singleCardWidth}px`;
        });
    }
}
if (!customElements.get('editorial-height-sync')) {
    customElements.define("editorial-height-sync", EditorialCardHeightSync);
}